import { render, staticRenderFns } from "./PostsPage.vue?vue&type=template&id=af9531e4&scoped=true&"
import script from "./PostsPage.vue?vue&type=script&lang=js&"
export * from "./PostsPage.vue?vue&type=script&lang=js&"
import style0 from "./PostsPage.vue?vue&type=style&index=0&id=af9531e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af9531e4",
  null
  
)

export default component.exports